import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/AppShell";
import { FeatureGate } from "@/components/UpgradeGate";
import { BusinessCasePanel } from "@/components/charts/BusinessCasePanel";

export const Route = createFileRoute("/_authenticated/visuals/business-case")({
  head: () => ({
    meta: [
      { title: "Business case builder — MyPriorities" },
      {
        name: "description",
        content:
          "Model revenue, cost, margin, mark-up, ARR and TCV in seconds, and save named business cases you can revisit.",
      },
      { property: "og:title", content: "Business case builder — MyPriorities" },
      {
        property: "og:description",
        content: "Quick commercials: revenue, cost, margin, ARR and TCV across a contract term.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: BusinessCaseRoute,
});

function BusinessCaseRoute() {
  return (
    <FeatureGate
      requires="pro"
      title="Business case builder"
      subtitle="Enter any two of revenue, cost or margin and the rest calculates, with ARR and TCV across the term."
    >
      <AppShell
        title="Business case builder"
        subtitle="Enter any two of revenue, cost or margin and the rest calculates, with ARR and TCV across the term."
      >
        <BusinessCasePanel />
      </AppShell>
    </FeatureGate>
  );
}
